import React from 'react';
import { Card } from './ui/Card';
import { Map, RefreshCw, Clock } from 'lucide-react';
export function SolutionSection() {
  const steps = [{
    icon: Map,
    title: '1. Mapa de Disparadores',
    desc: 'En minutos identificas las áreas con más probabilidad de estar disparando síntomas: laundry, baño, cocina, pisos y aire.'
  }, {
    icon: RefreshCw,
    title: '2. Swap por Zonas (14 días)',
    desc: 'No cambias todo de golpe. Cambias lo más importante primero. Cada zona tiene recetas específicas, simples y repetibles.'
  }, {
    icon: Clock,
    title: '3. Reset 10 minutos/día',
    desc: 'Porque el éxito no es una limpieza profunda una vez al mes. Es un sistema que no te roba la vida y se mantiene solo.'
  }];
  return <section className="py-16 md:py-24 bg-[#E8F0E6]/30" data-id="element-220">
      <div className="container mx-auto px-4 md:px-6" data-id="element-221">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-222">
          <span className="text-[#8B9D83] font-bold tracking-wider text-sm uppercase mb-2 block" data-id="element-223">
            El Mecanismo Único
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-[#44403C] mb-6" data-id="element-224">
            Rutina Low-Tox Anti-Alergias
          </h2>
          <p className="text-lg text-[#57534E]" data-id="element-225">
            Un sistema corto, por zonas, pensado para mamás con niños sensibles
            (0–12), en Estados Unidos, y en modo vida real.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto" data-id="element-226">
          {steps.map((step, index) => <Card key={index} className="relative overflow-hidden hover:shadow-lg transition-shadow duration-300" data-id="element-227">
              <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-[#E8F0E6] rounded-full opacity-50" data-id="element-228" />
              <div className="relative z-10" data-id="element-229">
                <div className="w-12 h-12 bg-[#8B9D83] rounded-xl flex items-center justify-center text-white mb-6 shadow-sm" data-id="element-230">
                  <step.icon className="w-6 h-6" data-id="element-231" />
                </div>
                <h3 className="text-xl font-bold text-[#44403C] mb-3" data-id="element-232">
                  {step.title}
                </h3>
                <p className="text-[#57534E] leading-relaxed" data-id="element-233">{step.desc}</p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}